<lib-renderer-container
  [params]="params"
  [tooltip]="params.value?.value | percent: '1.0-2'"
>
  {{ params.value?.value | percent: '1.0-2' }}
</lib-renderer-container>
